
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import CloseIcon from '@mui/icons-material/Close'
import { DialogActions, DialogContent, IconButton } from '@mui/material'

import './validateProfit.css'
import iconCheckOk from './iconCheckOk.svg'
import { TextAreas } from '../../reusableUI/TextAreas'

import { iniValidateProfit } from '../../../redux/actions/pptos'

export const ValidateProfit = ({ budgetId, open, setOpen }) => {

    const dispatch = useDispatch()
    const [comments, setComments] = useState('')

    const handleValidate = () => {
        dispatch(iniValidateProfit(budgetId, comments))
        setOpen(false)
    }

    const handleComentario = ({ target }) => {
        setComments(target.value)
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} className='p-dialog-approve'>
            <DialogTitle className='ColorTitleDocument' id="scroll-dialog-title">
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon
                        style={{ color: '#78667E' }}
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent className='content'>
                <div className='d-flex justify-content-center p-icons'>
                    <img src={iconCheckOk} alt="check okey" />
                </div>
                <div className='text'>
                    <h3>Validar rentabilidad</h3>
                    <p>¿Estás seguro de validar</p>
                    <p>la rentabilidad?</p>

                    <div className='p-text-comments m-3'>
                        <TextAreas
                            label='Comentario (opcional)'
                            name="comentario"
                            rows="2"
                            value={comments}
                            placeholder="Ingrese un comentario (opcional)"
                            onChange={handleComentario}
                        />
                    </div>

                    <p className='p-text-emisor'>Se notificará al solicitante una vez validado</p>
                </div>
            </DialogContent>
            <DialogActions className='d-flex justify-content-center mt-3 mb-2 p-actions'>
                <button className='cancel' onClick={() => setOpen(false)}>Cancelar</button>
                <button className='approve' onClick={handleValidate}>Validar</button>
            </DialogActions>
        </Dialog>
    );

}